import {useCallback} from "react"

export function PillGroup({...props}) {
  const {className, children, ...rest} = props
  const classNames = ["da-pill-group"]
  if (className) classNames.push(className)

  return (
    <div className={classNames.join(" ")} role="listbox" {...rest}>
      {children}
    </div>
  )
}

export function Pill({value, isSelected, onClick, ...props}) {
  const {className} = props

  const classNames = ["da-pill"]
  if (className) classNames.push(className)

  const handleOnClick = useCallback(() => {
    onClick && onClick(value?.value)
  }, [onClick, value])

  const handleKeyDown = useCallback((event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      handleOnClick()
    }
  }, [handleOnClick])

  return (
    <div
      className={classNames.join(" ")}
      role="option"
      tabIndex={0}
      aria-selected={!!isSelected}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
    >
      <span>{value.label}</span>
    </div>
  )
}
